var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.856934 7.9591H4.61122C4.7693 7.95728 4.92405 7.91346 5.05961 7.83212C5.19516 7.75079 5.30666 7.63487 5.38265 7.49624L8.46836 1.32481C8.54441 1.17116 8.66565 1.04446 8.81581 0.961719C8.96597 0.878979 9.13784 0.844167 9.30836 0.861957C9.4782 0.873436 9.6403 0.937305 9.77232 1.04476C9.90434 1.15222 9.99979 1.29798 10.0455 1.46196L13.8684 14.182C13.9185 14.3545 14.0217 14.5069 14.1632 14.6177C14.3047 14.7284 14.4774 14.7919 14.6569 14.7991C14.8252 14.7935 14.9881 14.7385 15.1252 14.641C15.2624 14.5434 15.3679 14.4076 15.4284 14.2505L17.7769 8.50767C17.8416 8.34658 17.9528 8.20838 18.0962 8.11068C18.2397 8.01299 18.4091 7.96022 18.5826 7.9591H23.1426",
    stroke: "#011A3C",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemStatus);
export default __webpack_public_path__ + "static/media/SystemStatus.f5e47f5716d0e6a633dfe0c63f772457.svg";
export { ForwardRef as ReactComponent };